import React, { useState, useEffect } from 'react';
import styles from './FilterModal.module.css';

export default function FilterModal({
  isOpen,
  onClose,
  title = 'Filtros Avançados',
  fields = [],
  initialValues = {},
  onApply,
  onClear,
}) {
  const [localValues, setLocalValues] = useState(initialValues);

  useEffect(() => {
    if (isOpen) {
      setLocalValues(initialValues);
    }
  }, [isOpen, initialValues]);

  if (!isOpen) return null;

  const handleChange = (field, value) => {
    setLocalValues((prev) => ({ ...prev, [field]: value }));
  };

  const handleApply = () => {
    onApply(localValues);
    onClose();
  };

  const handleClear = () => {
    const cleared = fields.reduce((acc, f) => {
      acc[f.name] = f.defaultValue || '';
      return acc;
    }, {});
    setLocalValues(cleared);
    if (onClear) onClear();
    onClose();
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.backdrop} onClick={onClose} />
      <div className={styles.modal}>
        <div className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
          <button onClick={onClose} className={styles.closeButton} aria-label="Fechar">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <div className={styles.body}>
          {fields.map((field) => (
            <div key={field.name} className={styles.field}>
              <label className={styles.label}>{field.label}</label>
              {field.type === 'select' ? (
                <select
                  className={styles.select}
                  value={localValues[field.name] || ''}
                  onChange={(e) => handleChange(field.name, e.target.value)}
                >
                  {field.options.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  type={field.type || 'text'}
                  className={styles.input}
                  value={localValues[field.name] || ''}
                  onChange={(e) => handleChange(field.name, e.target.value)}
                  placeholder={field.placeholder}
                />
              )}
            </div>
          ))}
        </div>

        <div className={styles.footer}>
          <button onClick={handleClear} className={styles.clearButton}>
            Limpar Filtros
          </button>
          <button onClick={handleApply} className={styles.applyButton}>
            Aplicar
          </button>
        </div>
      </div>
    </div>
  );
}
